$(function() {
    var $sliders = $('.js-slider');
    var current = 0;
    var timeoutId;
    var duration = 5000;

    function set(current) {
        $sliders.stop().animate({
            opacity: 0
        }, 500, function() {
            $sliders.removeClass('active');
            $($sliders[current]).addClass('active');
            $sliders.stop().animate({
                opacity: 1
            }, 500);
        });


        $('.js-slider-set').removeClass('active');
        $('.js-slider-set[data-slide-to="' + current + '"]').addClass('active');
        timeoutId = setTimeout(next, duration);
    }

    function next() {
        current++;

        if (current > $sliders.length - 1) {
            current = 0;
        }

        set(current);
    }

    function back() {
        current--;

        if (current < 0) {
            current = $sliders.length - 1;
        }

        set(current);
    }

    timeoutId = setTimeout(next, duration);

    $(document).on('click', '.js-slider-set', function() {
        clearTimeout(timeoutId);
        set($(this).attr('data-slide-to'));
    });

    $(document).on('click', '.js-slider-right', function() {
        clearTimeout(timeoutId);
        next();
    });
    $(document).on('click', '.js-slider-left', function() {
        clearTimeout(timeoutId);
        back();
    });
});